import React from 'react';
import { gql, useQuery } from '@apollo/client';

import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';

import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

const IdeaSubmitButton = ({ children }) => {
  const isMobile = useIsMobile();

  const { data, loading } = useQuery(gql`
    query IdeaSubmitButtonCurrentUser {
      currentUser {
        id
        isAllocator
        canWriteIdeas: canAccess(resource: "ideas", permission: "write")
      }
    }
  `);

  if (loading || !data) return null;

  const {
    currentUser: { isAllocator, canWriteIdeas }
  } = data;

  if (!isAllocator && canWriteIdeas) {
    if (children && typeof children === 'function') {
      return children({ canSubmitIdea: canWriteIdeas, isAllocator });
    }

    return <SubmitResearchButton size={isMobile ? 'tiniest' : 'small'} icon="" />;
  }

  return null;
};

export default IdeaSubmitButton;
